export const LEASE_OPTION_LIST = 'LEASE_OPTION_LIST';
export const LEASE_OPTION_ADD_SUCCESS = 'LEASE_OPTION_ADD_SUCCESS';
export const LEASE_OPTION_EDIT_SUCCESS = 'LEASE_OPTION_EDIT_SUCCESS';
export const LEASE_OPTION_LOADER = 'LEASE_OPTION_LOADER'
export const LEASE_OPTION_CRUD = 'LEASE_OPTION_CRUD';
export const TOGGLE_VIEW_EDIT = 'TOGGLE_VIEW_EDIT';
